var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui padded grid"},[_c('ProductListSelector',{staticClass:"ui five wide column",attrs:{"storeId":_vm.storeId,"productListId":_vm.productListId}}),_vm._v(" "),_c('router-view',{staticClass:"ui eleven wide column"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }